const mutations = {
  available (state, entity) {
    state.investments.available = entity
  },

  errorOnInvest (state, error) {
    state.investments.errorOnInvest = error
  },

  invest (state, entity) {
    state.investments.invest = entity
  },

  isInvestPending (state, status) {
    state.investments.isInvestPending = status
  }
}

export default mutations
